import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-14">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Shop by Category
          </h2>
          <p className="mt-3 text-lg text-foreground-500 font-light">
            14 Curated Sections
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-background-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} - pandabuyspreadsheet category`}
                  title={`PandabuySpreadsheet ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  View collection →
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}